// Auto-generated by RequirePageMetaPlugin
export const routeNames: Record<string, string> = {
  '/[language]/profile/past-orders/@modal/(.)[id]': 'Past Order Detail Modal',
  '/[language]/profile/account/change-password': 'Change Password',
  '/[language]/profile/account/invoice-information': 'Invoice Information',
  '/[language]/profile/account/payment-methods': 'Payment Methods',
  '/[language]/profile/account/phone-number': 'Phone Number',
  '/[language]/profile/account/privacy-settings': 'Privacy Settings',
  '/[language]/profile/order-invoices/[id]': 'Past Order Invoices',
  '/[language]/profile/past-orders/[id]': 'Past Order Detail',
  '/[language]/hosted-page-redirect/authorization': 'Authorization',
  '/[language]/hosted-page-redirect/tokenization': 'Tokenization',
  '/[language]/internal/address-book-desktop': 'Address Book Desktop',
  '/[language]/internal/address-book-mobile': 'Address Book Mobile',
  '/[language]/internal/checkout-cart': 'Checkout Iframe',
  '/[language]/internal/checkout-migration': 'Checkout Migration',
  '/[language]/internal/prime-migration': 'Prime Migration',
  '/[language]/internal/user-cart': 'User Cart Test',
  '/[language]/profile/account': 'Account',
  '/[language]/profile/language': 'Language',
  '/[language]/profile/promocodes': 'Promocodes',
  '/[language]/profile/past-orders': 'Past Orders',
  '/[language]/superapp/entry-point': 'Superapp entry point',
  '/[language]/superapp/home': 'Superapp Home',
  '/[language]/web-views/gifting': 'Gifting',
  '/[language]/web-views/privacy-management': 'Privacy Management',
  '/[language]/[country]/[city]/categories/[category]': 'Category',
  '/[language]/[country]/[city]/stores/[storeSlug]': 'Store',
  '/[language]/[country]/[city]/checkout': 'Checkout',
  '/[language]/[country]/[city]/order-summary': 'Checkout',
  '/[language]/[country]/[city]/search': 'Search',
  '/[language]/[country]/map/[cities]': 'Cities',
  '/[language]/courier-sign-contract/[uuid]': 'Courier Sign Contract',
  '/[language]/gifting/[id]': 'Gifting Detail',
  '/[language]/dummy': 'Dummy',
  '/[language]/gifting': 'Gifting',
  '/[language]/glovo-card': 'Glovo Card',
  '/[language]/google-auth': 'Google Auth',
  '/[language]/healthcheck': 'Healthcheck',
  '/[language]/login': 'Login',
  '/[language]/not-found': 'Not found',
  '/[language]/orders': 'Orders',
  '/[language]/package-delivery': 'Package Delivery',
  '/[language]/password-recovery': 'Password Recovery',
  '/[language]/profile': 'Profile',
  '/[language]/security': 'Security',
  '/[language]/[country]/[city]': 'City',
  '/[language]/[country]': 'Country',
  '/[language]': 'Global',
};
